/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrganizationalValue
 */
export interface OrganizationalValue {
    /**
     * 
     * @type {string}
     * @memberof OrganizationalValue
     */
    controlId?: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationalValue
     */
    parameterId?: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationalValue
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationalValue
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationalValue
     */
    value?: string;
}

/**
 * Check if a given object implements the OrganizationalValue interface.
 */
export function instanceOfOrganizationalValue(value: object): value is OrganizationalValue {
    return true;
}

export function OrganizationalValueFromJSON(json: any): OrganizationalValue {
    return OrganizationalValueFromJSONTyped(json, false);
}

export function OrganizationalValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationalValue {
    if (json == null) {
        return json;
    }
    return {
        
        'controlId': json['controlId'] == null ? undefined : json['controlId'],
        'parameterId': json['parameterId'] == null ? undefined : json['parameterId'],
        'type': json['type'] == null ? undefined : json['type'],
        'description': json['description'] == null ? undefined : json['description'],
        'value': json['value'] == null ? undefined : json['value'],
    };
}

export function OrganizationalValueToJSON(json: any): OrganizationalValue {
    return OrganizationalValueToJSONTyped(json, false);
}

export function OrganizationalValueToJSONTyped(value?: OrganizationalValue | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'controlId': value['controlId'],
        'parameterId': value['parameterId'],
        'type': value['type'],
        'description': value['description'],
        'value': value['value'],
    };
}

